import React from "react";

export default function TRIM() {
  return <div>Excel_TRIM</div>;
}
